<template>
<footer class="footer">
  <div class="footer-content">
    <div class="footer-container">
      <div class="footer-brand">
        <div class="footer-logo">
          <span class="logo-text">GBWhatsApp</span>
        </div>
        <p class="footer-tagline">Your trusted source for modified WhatsApp</p>
      </div>

      <nav class="footer-menu">
        <div class="footer-menu-section">
          <span class="footer-menu-title">Legal &amp; Info</span>
          <div class="footer-links">
            <router-link v-for="item in legalLinks" :key="item.path" :to="basePath + item.path" class="footer-link">{{ item.label }}</router-link>
          </div>
        </div>
      </nav>

      <div class="footer-note">
        <p>© 2025 <router-link to="/" class="footer-link">gbwhetsapp.com</router-link> All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      mainLinks: [
        { label: 'Home', path: '/' },
        { label: 'Download', path: '/download/' },
        { label: 'Blogs', path: '/blog/' },
      ],
      legalLinks: [
        { label: 'Privacy Policy', path: '/privacy-policy/' },
        { label: 'Terms of Service', path: '/terms-of-service/' },
        { label: 'DMCA', path: '/dmca/' },
        { label: 'Disclaimer', path: '/disclaimer/' },
      ],
    };
  },
  computed: {
    basePath() {
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=Outfit:wght@400;500;600;700&display=swap');

.footer {
  position: relative;
  background: var(--theme-page-bg, #f7f9f7);
  margin-top: 28px;
}

.footer-content {
  background: var(--theme-footer-gradient, linear-gradient(135deg, #047857 0%, #059669 100%));
  padding: 34px 0 22px;
  border-radius: 28px 28px 0 0;
}

.footer-container {
  width: 1080px;
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.footer-brand {
  text-align: center;
}

.footer-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 8px;

  .logo-icon {
    font-size: 28px;
    animation: leafFloat 3s ease-in-out infinite;
  }

  .logo-text {
    font-family: 'Outfit', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: var(--theme-footer-text, #ffffff);
    letter-spacing: -0.5px;
  }
}

@keyframes leafFloat {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-4px) rotate(5deg); }
}

.footer-tagline {
  font-family: 'DM Sans', sans-serif;
  color: var(--theme-footer-text-muted, rgba(255,255,255,0.75));
  font-size: 13px;
  margin: 0;
}

.footer-menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px 36px;
  width: 100%;
  max-width: 900px;
}

.footer-menu-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-menu-title {
  font-family: 'Outfit', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: var(--theme-footer-text-muted, rgba(255,255,255,0.5));
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 10px 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-link {
  font-family: 'DM Sans', sans-serif;
  color: var(--theme-footer-link, rgba(255,255,255,0.85));
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 8px;
  transition: all 0.25s ease;

  &:hover {
    color: var(--theme-footer-link-hover, #ffffff);
    background: var(--theme-border-inverse, rgba(255,255,255,0.15));
    transform: translateY(-2px);
  }

  &.router-link-active {
    color: var(--theme-footer-link-hover, #ffffff);
    background: var(--theme-border-inverse, rgba(255,255,255,0.2));
  }
}

.footer-note {
  font-family: 'DM Sans', sans-serif;
  font-size: 12.5px;
  color: var(--theme-footer-text-muted, rgba(255,255,255,0.6));
  text-align: center;

  p { margin: 0; }

  .footer-link {
    padding: 0;
    font-weight: 600;

    &:hover {
      background: transparent;
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .footer {
    margin-top: 20px;
  }

  .footer-content {
    padding: 28px 0 18px;
    border-radius: 22px 22px 0 0;
  }

  .footer-menu {
    flex-direction: column;
    gap: 16px;
  }

  .footer-menu-section {
    width: 100%;
  }

  .footer-links {
    gap: 8px;
  }

  .footer-logo {
    .logo-icon { font-size: 24px; }
    .logo-text { font-size: 20px; }
  }
}
</style>
